import { translate } from '@utils/i18n';
import { VersionEvent } from '../types';
import { IndexNamespace } from '../constants';
// Legacy DeficiencyHistory rows arrive with empty `changes` -- the event itself is the
// whole story ("was marked as resolved"), so they are labelled from the event alone.
const versionEventLabels = {
    [VersionEvent.Create]: translate('created', { namespace: IndexNamespace }),
    [VersionEvent.Created]: translate('created', { namespace: IndexNamespace }),
    [VersionEvent.Update]: translate('details_updated', { namespace: IndexNamespace }),
    [VersionEvent.MarkedAsResolved]: translate('marked_as_resolved', { namespace: IndexNamespace }),
    [VersionEvent.MarkedAsUnresolved]: translate('marked_as_unresolved', { namespace: IndexNamespace }),
    [VersionEvent.AddedToInspection]: translate('added_to_inspection', { namespace: IndexNamespace }),
    [VersionEvent.AddedToProposal]: translate('added_to_proposal', { namespace: IndexNamespace }),
    [VersionEvent.LinkedToProposal]: translate('linked_to_proposal', { namespace: IndexNamespace })
};
export default versionEventLabels;
// `update` is excluded on purpose: "details updated" with nothing to show is the empty
// row IP-15308 removed, and treating it as renderable would bring it back.
export function isSelfDescribingEvent(activity) {
    if ('notes' in activity) {
        return false;
    }
    return activity.event !== VersionEvent.Update && !!versionEventLabels[activity.event];
}
